import { UnidataUrlData } from '../../libs/controls/Grid/interfaces';

export const mapUrlOptions = (
  array: Array<UnidataUrlData['extra']>,
  extra?: { value: string; label: string },
) => {
  if (!Array.isArray(array)) {
    return [];
  }

  return array?.map((item) => ({
    ...item,
    value: item?.[extra?.value]
      ? item[extra.value]
      : item?.key || item?.id || item?.name,
    label: item?.[extra?.label] ? item[extra.label] : item?.name,
  }));
};
